var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsibleGambling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "3 0 20 20",
    fill: "#ADF106",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8787_5119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 3.15625L10.6875 5.65625C10.875 5.8125 11 6.03125 11 6.25V7.9375L14.4062 11.3438C15.3125 10.9062 16.4375 11.0625 17.1875 11.8125L20.6875 15.3125C21.0938 15.6875 21.0938 16.3438 20.6875 16.7188L18.6875 18.7188C18.3125 19.125 17.6562 19.125 17.2812 18.7188L13.7812 15.2188C13.0312 14.4688 12.875 13.3125 13.3438 12.4062L9.9375 9H8.21875C8 9 7.78125 8.90625 7.625 8.71875L5.125 5.46875C4.90625 5.15625 4.9375 4.75 5.21875 4.46875L6.46875 3.21875C6.71875 2.96875 7.15625 2.9375 7.4375 3.15625ZM5.59375 15.4062L10.25 10.75L12.1875 12.6875C12 13.3438 12.0312 14.0625 12.2812 14.7188L8.59375 18.4062C8.21875 18.7812 7.65625 19 7.09375 19C5.9375 19 5 18.0625 5 16.9062C5 16.3438 5.21875 15.7812 5.59375 15.4062ZM21 7.5C21 9.3125 19.9375 10.875 18.4062 11.5938L17.9062 11.0938C17.0312 10.2188 15.7812 9.90625 14.6562 10.2188L12 7.53125V7.5C12 5.03125 14 3 16.5 3C16.8125 3 17.125 3.0625 17.4375 3.125C17.7812 3.1875 17.875 3.625 17.625 3.875L15.625 5.875C15.5312 5.96875 15.5 6.09375 15.5 6.21875V8.03125C15.5 8.28125 15.7188 8.53125 16 8.53125H17.7812C17.9062 8.53125 18.0312 8.46875 18.125 8.375L20.125 6.375C20.375 6.125 20.8125 6.21875 20.875 6.5625C20.9375 6.875 21 7.1875 21 7.5ZM6.75 16.5C6.75 16.9375 7.0625 17.25 7.5 17.25C7.90625 17.25 8.25 16.9375 8.25 16.5C8.25 16.0938 7.90625 15.75 7.5 15.75C7.0625 15.75 6.75 16.0938 6.75 16.5Z",
    fill: "#ADF106"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8787_5119",
    x: 0.90625,
    y: 0.9375,
    width: 24.1875,
    height: 24.1875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8787_5119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8787_5119",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsibleGambling);
export default ForwardRef;